import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Icon from 'HTKit/Icon';
import Tooltip from 'src/components/HTKit/Elements/Tooltip';
import styles from './styles.scss';

export const WarningHintIcon = ({ content, checkbox, className }) => {
  const hintIconStyles = cn(styles.hintIcon, className, {
    [styles.checkboxHint]: checkbox,
  });
  return (
    <Tooltip content={content} wrapperClass={hintIconStyles} align="right">
      <Icon name="info-outline" />
    </Tooltip>
  );
};

WarningHintIcon.propTypes = {
  content: PropTypes.string.isRequired,
  checkbox: PropTypes.bool,
  className: PropTypes.string,
};
